import { gql } from '@apollo/client';

export const PRODUCT_SEARCH = gql`
    fragment ProductSearchFields on ProductDocument {
        id
        sku
        productName
        ean
        packagingSize
        supplierId
        supplierName
        productCocontractorValue
        image
        procuredProduct
        productCocontractor
        salesUnit
        quantityUnit
        category
        hasAccessories
        hasAlternatives
        bonus
        availability
        customerArticleNumber
    }
`;
